module.exports = __webpack_public_path__ + "img/agriculture-explore.d3b3f509.jpg";